import React from "react";
import Translate from "react-translate-component";
// import { loadStripe } from "@stripe/stripe-js";
import { Elements, useStripe } from "@stripe/react-stripe-js";
import { FaStar } from "react-icons/fa";
import { BiCheck, BiPaperPlane, BiRocket } from "react-icons/bi";

import AppComponent from "@app@::@component";
// import Payment from "@components/page/payment.component";
import AppUtil from "@app@::@util";
import AppData from "@app@::@data";

import { DataType } from "@route@::@premium:hook";
// const StripeClient = loadStripe(AppData.project.stripe.key, { apiVersion: AppData.project.stripe. });

const SectionContent: React.FC<{ data: DataType; utils: any; refetchData: any; update: any }> = ({ update, data: { profile }, refetchData, utils }) => {
    const backgroundObjects = React.useState(<AppComponent.BackgroundObjects totalObjects={7} positionLimit={[-10, 100]} sizeLimit={[100, 800]} />);
    // const yearlyActive = React.useState<boolean>(false); // If the monthly tab is active
    const confirmPaymentPopupTrigger = React.useState<boolean>(false); // The Toggle for the confirm payment pop up
    const premiumActivatedPopupTrigger = React.useState<boolean>(false); // The Toggle for when the user becomes premium
    const selectedPlans = React.useState<any[]>([]); // The plans that are selected
    const error = React.useState<string>(""); // The state that holds the error

    const stripe = useStripe(); // Stripe stuff

    return (
        <>
            <section className="content-area">
                <div className="relative w-screen h-screen overflow-hidden">
                    {backgroundObjects[0]}
                    <div className="absolute top-10 left-[69%] w-[400px]">
                        <img className="tb-drop-shadow absolute top-[365px] right-0 h-[600px] tb-float-02" src={`${process.env.PUBLIC_URL}/media/png/TitanPremium 01 02.png`} alt="" />
                        <img className="tb-drop-shadow absolute right-20 h-[600px] tb-float-01" src={`${process.env.PUBLIC_URL}/media/png/TitanPremium 01 01.png`} alt="" />
                        <img className="tb-drop-shadow absolute top-[230px] right-[370px] h-[730px] tb-float-03" src={`${process.env.PUBLIC_URL}/media/png/TitanPremium 01 03.png`} alt="" />
                    </div>
                    <div className="relative container mx-auto">
                        <div className="pricing-table-container">
                            <div className="pricing-header mt-4">
                                <h2 className="text title-6 text-center">
                                    Titan-Bot <Translate content="words.premium" />
                                </h2>
                            </div>
                            <div className="pricing-table my-14">
                                <div className="table right">
                                    <div className="content">
                                        <Translate content="routes.premium.server.name" component="h3" />

                                        <div className="price-container">
                                            <span className="price server-price">$5</span>
                                            <span className="plan-duration">
                                                USD / <Translate content="words.month" />
                                            </span>
                                        </div>

                                        <Translate content="routes.premium.server.description" className="description" />

                                        <ul className="features">
                                            {["refund", "better_verification", "modules_plus", "transferable", "plus_more"].map((value, index) => (
                                                <li key={index}>
                                                    <AppComponent.Tooltip content={<Translate content={`routes.premium.features.${value}_i`} />} children={<span className="icon" children={<BiCheck />} />} />
                                                    <Translate content={`routes.premium.features.${value}`} />
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="table best-value">
                                    <Translate content="routes.premium.recommended" className="value" />
                                    <div className="content">
                                        <Translate content="routes.premium.profile.name" component="h3" />

                                        <div className="price-container">
                                            <span className="price profile-price">$10</span>
                                            <span className="plan-duration">
                                                USD / <Translate content="words.month" />
                                            </span>
                                        </div>

                                        <Translate content="routes.premium.profile.description" className="description" />

                                        <ul className="features">
                                            {["refund", "premium_servers", "double_rewards", "premium_commands", "early_access", "plus_more"].map((value, index) => (
                                                <li key={index}>
                                                    <AppComponent.Tooltip content={<Translate content={`routes.premium.features.${value}_i`} />} children={<span className="icon" children={<BiCheck />} />} />
                                                    <Translate content={`routes.premium.features.${value}`} />
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* {profile && (
                <>
                    <AppComponent.PopUp id="PremiumActivatedPopup" trigger={premiumActivatedPopupTrigger} close closeFull outside={<AppComponent.BackgroundObjects totalObjects={100} positionLimit={[-10, 100]} sizeLimit={[5, 100]} colors={["#f2dc6f", "#ffca38"]} float />} utils={utils}>
                        <h1 className="text title-5 text-center">
                            <Translate content="words.yay" />
                            !! ヾ(≧▽≦*)o
                        </h1>
                        <img className="mx-auto my-4 w-[150px]" src={`${process.env.PUBLIC_URL}/media/png/shooting-star.png`} alt="yay" />
                        <Translate content="routes.premium.complete" component="p" className="text subtitle-4 text-center" unsafe />
                    </AppComponent.PopUp>
                    <AppComponent.PopUp id="ConfirmPaymentPopup" trigger={confirmPaymentPopupTrigger} close closeFull utils={utils}>
                        <h1 className="text title-6 text-center">
                            Titan-Bot <Translate content="words.premium" />
                        </h1>
                        <div className="mb-5"></div>
                        {error[0].length > 1 && (
                            <div className="px-3 py-1 text-[16px] bg-[#ff858530] rounded-md mb-3">
                                <Translate content={`notifications.stripe.${error[0]}`} component="p" className="text error" />
                            </div>
                        )}
                        <Payment.ConfirmPayment profile={profile} items={selectedPlans} />
                        <div className="button flex justify-between mt-5">
                            <button
                                className="hover02 color-secondary drop-shadow-lg"
                                onClick={() => {
                                    confirmPaymentPopupTrigger[1](false);
                                    error[1]("");
                                }}>
                                <Translate content="words.cancel" component="span" className="button-text" />
                            </button>
                            <button
                                className={`hover01 color-primary drop-shadow-lg ${profile.customer.invoice_settings.default_payment_method ? "" : "disabled"}`}
                                onClick={async () => {
                                    error[1]("");
                                    const body = document.querySelector("body");
                                    body?.classList.add("load");
                                    const subscribe = await AppUtil.CreateSubmitSubscriptionStripe(stripe, { items: selectedPlans[0] });
                                    body?.classList.remove("load");
                                    if (subscribe.success) window.location.href = `/profile?section=subscription`;
                                    else error[1](subscribe.error?.code as string);
                                }}>
                                <span className="button-icon both">
                                    <FaStar />
                                </span>
                                <Translate content="words.subscribe" component="span" className="button-text" />
                            </button>
                        </div>
                    </AppComponent.PopUp>
                </>
            )} */}
        </>
    );
};

const Section: React.FC<{ data: DataType; utils: any; refetchData: any; update: any }> = (props) => {
    return <SectionContent {...props} />;
};

const Components = { Section };

export default Components;

/*
                <div className="relative full-divider" />
                 <div className="default-container premium-tables">
                    <div className="container mx-auto my-16 px-4">
                        <h1 className="text title-6">Profile Premium Features</h1>
                        <table className="base-table drop-shadow-lg premium-table">
                            <thead className="drop-shadow-lg">
                                <tr>
                                    <th>Feature</th>
                                    <th className="text-center">
                                        <span className="value">Free</span>
                                        <span className="icon">🚫</span>
                                    </th>
                                    <th className="text-center">
                                        <span className="value">Premium</span>
                                        <span className="icon">⭐</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Profile XP reward rate.</td>
                                    <td className="text-center">1x</td>
                                    <td className="text-center">2x</td>
                                </tr>
                                <tr>
                                    <td>Daily rewards.</td>
                                    <td className="my-auto premium-status premium-status-success">
                                        <BiCheck className="icon" />
                                    </td>
                                    <td className="my-auto premium-status premium-status-success">
                                        <BiCheck className="icon" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Daily reward of pawcoins.</td>
                                    <td className="text-center">To 1000</td>
                                    <td className="text-center">To 3000</td>
                                </tr>
                                <tr>
                                    <td>Discount on store purchases.</td>
                                    <td className="my-auto premium-status premium-status-danger">
                                        <BiX className="icon" />
                                    </td>
                                    <td className="my-auto premium-status premium-status-success">
                                        <BiCheck className="icon" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Use premium server commands in non-premium servers.</td>
                                    <td className="my-auto premium-status premium-status-danger">
                                        <BiX className="icon" />
                                    </td>
                                    <td className="my-auto premium-status premium-status-success">
                                        <BiCheck className="icon" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Play cool games through the bot.</td>
                                    <td className="my-auto premium-status premium-status-success">
                                        <BiCheck className="icon" />
                                    </td>
                                    <td className="my-auto premium-status premium-status-success">
                                        <BiCheck className="icon" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Build a profile page.</td>
                                    <td className="my-auto premium-status premium-status-success">
                                        <BiCheck className="icon" />
                                    </td>
                                    <td className="my-auto premium-status premium-status-success">
                                        <BiCheck className="icon" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Create posts on profile page.</td>
                                    <td className="text-center">1 per Day</td>
                                    <td className="text-center">Unlimited</td>
                                </tr>
                                <tr>
                                    <td>Additional profile page customization.</td>
                                    <td className="my-auto premium-status premium-status-danger">
                                        <BiX className="icon" />
                                    </td>
                                    <td className="my-auto premium-status premium-status-success">
                                        <BiCheck className="icon" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Sell and buy items using pawcoins through the economy shop.</td>
                                    <td className="my-auto premium-status premium-status-success">
                                        <BiCheck className="icon" />
                                    </td>
                                    <td className="my-auto premium-status premium-status-success">
                                        <BiCheck className="icon" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="container mx-auto my-16 px-4">
                        <h1 className="text title-6">Server Premium Features</h1>
                        <table className="base-table drop-shadow-lg  premium-table">
                            <thead className="drop-shadow-lg">
                                <tr>
                                    <th>Feature</th>
                                    <th className="text-center">
                                        <span className="value">Free</span>
                                        <span className="icon">🚫</span>
                                    </th>
                                    <th className="text-center">
                                        <span className="value">Premium</span>
                                        <span className="icon">⭐</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Test</td>
                                    <td className="my-auto premium-status premium-status-danger">
                                        <BiX className="icon" />
                                    </td>
                                    <td className="my-auto premium-status premium-status-success">
                                        <BiCheck className="icon" />
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <div className="button flex justify-center">
                                            <button
                                                className="hover01 color-success drop-shadow-lg"
                                                onClick={() => {
                                                    if (!profile) return (window.location.href = `${AppData.project.backendDomain}/api/auth/login`);
                                                    confirmPaymentPopupTrigger[1](true);
                                                    selectedPlans[1]([{ id: yearlyActive[0] ? 3 : 2, quantity: 1 }]);
                                                }}>
                                                <span className="button-icon">
                                                    <BiCrown />
                                                </span>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div> */
